export default "__VITE_ASSET__CG6E06eC__"